import { createHead } from "@unhead/vue/client";
import { createApp, nextTick } from "vue";

import App from "@/app/App.vue";
import { router } from "@/app/router";
import { initAnalytics, trackPageView } from "@/shared/lib/analytics";

import "@/styles/main.css";

// Client-side <head> manager — keeps title / meta / canonical / og /
// JSON-LD in sync with the current route as the user navigates
// SPA-internally (no full reload). For the FIRST request the head is
// already correct because routes/spa-head.js injected per-product meta
// into the SPA shell server-side; this plugin takes over on hydration.
const head = createHead();

// GA4 — no-op when VITE_GA4_MEASUREMENT_ID isn't set, so dev & staging
// stay clean. page_view is fired manually on every route change so the
// SPA's client-side navigation is captured (gtag's send_page_view only
// fires once per script load).
initAnalytics();
router.afterEach((to) => {
  // Wait a tick so useHead() has flushed the new <title> before we
  // read document.title for the page_view payload.
  nextTick(() => trackPageView(to.fullPath, document.title));
});

createApp(App).use(router).use(head).mount("#app");
